import Axios from "axios";
import config from "../api/config";
import API from "../api/manager";

const getS3URL = (data) => {
  return API({
    method: "POST",
    url: config.urls.s3,
    data,
  });
};

const uploadToS3 = (url, file) => {
  return new Promise((resolve, reject) => {
    Axios.put(url, file, {
      headers: {
        "Content-Type": file?.type,
      },
    })
      .then((_) => {
        resolve(url?.split("?")[0]);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default { getS3URL, uploadToS3 };
